import type { MemoizedFn } from 'memoize-one';
import memoizeOne from 'memoize-one';
import type { JsonLd } from 'json-ld-types';

import { InlineCommentEditorCardProvider } from '@confluence/comments-util/entry-points/classes.ts';
import { ConfluenceEditorCardProvider } from '@confluence/smartlinks';

export const getSmartCardOptions: MemoizedFn<
	(enableChromelessEditorCardProvider: boolean) => {
		provider: Promise<ConfluenceEditorCardProvider>;
		resolveBeforeMacros: string[];
		allowBlockCards: boolean;
		allowEmbeds: boolean;
	}
> = memoizeOne(
	(
		enableChromelessEditorCardProvider: boolean,
	): {
		provider: Promise<ConfluenceEditorCardProvider>;
		resolveBeforeMacros: string[];
		allowBlockCards: boolean;
		allowEmbeds: boolean;
	} => {
		/**
		 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
		 * (only supports Cloud single-issue URLs right now)
		 */
		const smartLinksBeforeMacros =
			'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(
				',',
			);

		const cardProvider = enableChromelessEditorCardProvider
			? new InlineCommentEditorCardProvider()
			: new ConfluenceEditorCardProvider();

		if (!enableChromelessEditorCardProvider) {
			const ssrProvidersData: { editorCardProvider?: Record<string, JsonLd.Response> } =
				window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
			const ssrData = ssrProvidersData[cardProvider.name];

			cardProvider.setSSRData(ssrData);
		}

		// IMPORTANT: If you change the code below, please also update the
		// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/pastePluginOptions.ts
		// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/cardPluginOptions.ts
		return {
			provider: Promise.resolve(cardProvider),
			resolveBeforeMacros: smartLinksBeforeMacros,
			allowBlockCards: true,
			allowEmbeds: true,
		};
	},
);
